const europeanCountries = {
  al: 'Albania',
  ad: 'Andorra',
  at: 'Austria',
  by: 'Belarus',
  be: 'Belgium',
  ba: 'Bosnia and Herzegovina',
  bg: 'Bulgaria',
  hr: 'Croatia',
  cz: 'Czech Republic',
  dk: 'Denmark',
  ee: 'Estonia',
  fi: 'Finland',
  fr: 'France',
  de: 'Germany',
  gr: 'Greece',
  va: 'Holy See (Vatican City State)',
  hu: 'Hungary',
  is: 'Iceland',
  ie: 'Ireland',
  it: 'Italy',
  lv: 'Latvia',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mk: 'Macedonia, the Former Yugoslav Republic of',
  mt: 'Malta',
  md: 'Moldova, Republic of',
  mc: 'Monaco',
  me: 'Montenegro',
  nl: 'Netherlands',
  no: 'Norway',
  pl: 'Poland',
  pt: 'Portugal',
  ro: 'Romania',
  sm: 'San Marino',
  rs: 'Serbia',
  sk: 'Slovakia',
  si: 'Slovenia',
  es: 'Spain',
  se: 'Sweden',
  ch: 'Switzerland',
  ua: 'Ukraine',
  gb: 'United Kingdom',
};

const restOfWorldCountries = {
  af: 'Afghanistan',
  ax: 'Åland Islands',
  dz: 'Algeria',
  as: 'American Samoa',
  ao: 'Angola',
  ai: 'Anguilla',
  aq: 'Antarctica',
  ag: 'Antigua and Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  aw: 'Aruba',
  au: 'Australia',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  bz: 'Belize',
  bj: 'Benin',
  bm: 'Bermuda',
  bt: 'Bhutan',
  bo: 'Bolivia, Plurinational State of',
  bq: 'Bonaire, Sint Eustatius and Saba',
  bw: 'Botswana',
  bv: 'Bouvet Island',
  br: 'Brazil',
  io: 'British Indian Ocean Territory',
  bn: 'Brunei Darussalam',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cv: 'Cape Verde',
  ky: 'Cayman Islands',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  cx: 'Christmas Island',
  cc: 'Cocos (Keeling) Islands',
  co: 'Colombia',
  km: 'Comoros',
  cg: 'Congo',
  cd: 'Congo, the Democratic Republic of the',
  ck: 'Cook Islands',
  cr: 'Costa Rica',
  ci: "Côte d'Ivoire",
  cu: 'Cuba',
  cw: 'Curaçao',
  cy: 'Cyprus',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  sz: 'Eswatini',
  et: 'Ethiopia',
  fk: 'Falkland Islands (Malvinas)',
  fo: 'Faroe Islands',
  fj: 'Fiji',
  gf: 'French Guiana',
  pf: 'French Polynesia',
  tf: 'French Southern Territories',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gl: 'Greenland',
  gd: 'Grenada',
  gp: 'Guadeloupe',
  gu: 'Guam',
  gt: 'Guatemala',
  gg: 'Guernsey',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hm: 'Heard Island and McDonald Islands',
  hn: 'Honduras',
  hk: 'Hong Kong',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran, Islamic Republic of',
  iq: 'Iraq',
  im: 'Isle of Man',
  il: 'Israel',
  jm: 'Jamaica',
  jp: 'Japan',
  je: 'Jersey',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  kp: "Korea, Democratic People's Republic of",
  kr: 'Korea, Republic of',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: "Lao People's Democratic Republic",
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libya',
  mo: 'Macao',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mh: 'Marshall Islands',
  mq: 'Martinique',
  mr: 'Mauritania',
  mu: 'Mauritius',
  yt: 'Mayotte',
  mx: 'Mexico',
  fm: 'Micronesia, Federated States of',
  mn: 'Mongolia',
  ms: 'Montserrat',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nc: 'New Caledonia',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  nu: 'Niue',
  nf: 'Norfolk Island',
  mp: 'Northern Mariana Islands',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestine, State of',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pn: 'Pitcairn',
  pr: 'Puerto Rico',
  qa: 'Qatar',
  re: 'Réunion',
  ru: 'Russian Federation',
  rw: 'Rwanda',
  bl: 'Saint Barthélemy',
  sh: 'Saint Helena, Ascension and Tristan da Cunha',
  kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia',
  mf: 'Saint Martin (French part)',
  pm: 'Saint Pierre and Miquelon',
  vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa',
  st: 'Sao Tome and Principe',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sx: 'Sint Maarten (Dutch part)',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  gs: 'South Georgia and the South Sandwich Islands',
  ss: 'South Sudan',
  lk: 'Sri Lanka',
  sd: 'Sudan',
  sr: 'Suriname',
  sj: 'Svalbard and Jan Mayen',
  sy: 'Syrian Arab Republic',
  tw: 'Taiwan, Province of China',
  tj: 'Tajikistan',
  tz: 'Tanzania, United Republic of',
  th: 'Thailand',
  tl: 'Timor-Leste',
  tg: 'Togo',
  tk: 'Tokelau',
  to: 'Tonga',
  tt: 'Trinidad and Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tc: 'Turks and Caicos Islands',
  tv: 'Tuvalu',
  ug: 'Uganda',
  ae: 'United Arab Emirates',
  us: 'United States',
  um: 'United States Minor Outlying Islands',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  ve: 'Venezuela, Bolivarian Republic of',
  vn: 'Viet Nam',
  vg: 'Virgin Islands, British',
  vi: 'Virgin Islands, U.S.',
  wf: 'Wallis and Futuna',
  eh: 'Western Sahara',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};

export const recipientCountryOptions = [
  { label: 'Europe', options: Object.entries(europeanCountries).map(([value, label]) => ({ value, label })) },
  { options: Object.entries(restOfWorldCountries).map(([value, label]) => ({ value, label })) },
];
